import { FC } from 'react';
import { ColorIcon } from '@lambdacurry/component-library';

export interface PaymentMethodIconProps {
  brand: string;
}

export const stripeBrandToIconMap = {
  amex: 'americanExpress',
  diners: 'dinersClub',
  discover: 'discoverCard',
  jcb: 'jcb',
  mastercard: 'masterCard',
  visa: 'visa',
  unionpay: 'unionPay'
};

export const PaymentMethodIcon: FC<PaymentMethodIconProps> = ({ brand }) => (
  <ColorIcon
    className="flex-shrink-0 !h-[40px] !w-[40px] md:!h-[52px] md:!w-[52px]"
    name={stripeBrandToIconMap[brand] || 'creditCard'}
  />
);
